// extracted by mini-css-extract-plugin
module.exports = {"item":"Tasks_item_2-1fo","headerText":"Tasks_headerText_2MNKC","container":"Tasks_container_2R8gP","img":"Tasks_img_1PC8o","containerCount":"Tasks_containerCount_3yxiI"};